import { render, staticRenderFns } from "./newscreen.vue?vue&type=template&id=43e318d6&scoped=true&"
import script from "./newscreen.vue?vue&type=script&lang=ts&"
export * from "./newscreen.vue?vue&type=script&lang=ts&"
import style0 from "./newscreen.vue?vue&type=style&index=0&id=43e318d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e318d6",
  null
  
)

export default component.exports